import { createInitialPlayerData } from '../collection/data/playerData';
import type { EconomySnapshot } from './economyClient';

const ASSET_FIELDS = ['gold', 'unopenedPacks', 'unopenedPacksByType', 'collection', 'stats',
  'investmentData', 'merchantData', 'tradeData', 'tournamentData', 'economyUserId', 'economyVersion', 'economyBattleNumber'];

export function applyEconomySnapshot(previous: any, snapshot: EconomySnapshot, account: string | null): any {
  if (!snapshot || snapshot.user_id !== account || !Number.isSafeInteger(snapshot.economy_version)) return previous;
  if (previous?.economyUserId === account && previous.economyVersion > snapshot.economy_version) return previous;
  const defaults = createInitialPlayerData();
  const sameAccount = !previous?.economyUserId || previous.economyUserId === account;
  const base = sameAccount ? previous ?? defaults : { ...defaults, settings: previous?.settings, twinKey: previous?.twinKey };
  return { ...base, gold: snapshot.gold, unopenedPacks: snapshot.unopened_packs,
    unopenedPacksByType: snapshot.unopened_packs_by_type, collection: snapshot.collection,
    stats: { ...defaults.stats, ...snapshot.stats },
    investmentData: { ...defaults.investmentData, ...snapshot.investment_data,
      totalStats: { ...defaults.investmentData.totalStats, ...snapshot.investment_data?.totalStats } },
    merchantData: { ...defaults.merchantData, ...snapshot.merchant_data,
      wishlist: sameAccount ? base.merchantData?.wishlist ?? [] : [] },
    tradeData: { ...defaults.tradeData, ...snapshot.trade_data },
    tournamentData: { ...defaults.tournamentData, ...snapshot.tournament_data,
      totalStats: { ...defaults.tournamentData.totalStats, ...snapshot.tournament_data?.totalStats } },
    adventureProgress: snapshot.adventure_data,
    economyUserId: account, economyVersion: snapshot.economy_version, economyBattleNumber: snapshot.economy_battle_number,
  };
}

// Asset commands go through the server. UI callbacks may still edit local
// settings, decks, exploration progress and presentation state.
export function preserveOnlineAssets(previous: any, candidate: any, online: boolean): any {
  if (!online || !previous || !candidate) return candidate;
  const result = { ...candidate };
  for (const field of ASSET_FIELDS) result[field] = previous[field];
  if (candidate.merchantData?.wishlist) result.merchantData = { ...previous.merchantData, wishlist: candidate.merchantData.wishlist };
  return result;
}
